import CryptoJS from 'crypto-js'
const KEY = CryptoJS.enc.Utf8.parse('730731840fbc381c')

// 加密数据
export function encrypt(data) {
  if (typeof data === 'object') {
    // 如果传入的data是json对象，先转义为json字符串
    try {
      data = JSON.stringify(data)
    } catch (error) {
      console.log('error:', error)
    }
  }
  // 统一将传入的字符串转成UTF8编码
  const dataHex = CryptoJS.enc.Utf8.parse(data) // 需要加密的数据
  const encrypted = CryptoJS.AES.encrypt(dataHex, KEY, {
    mode: CryptoJS.mode.ECB, // 加密模式
    padding: CryptoJS.pad.Pkcs7,
  })
  let encryptedVal = encrypted.ciphertext.toString()
  return encryptedVal //  返回加密后的值
}

// 解密数据
export function decrypt(encryptedVal) {
  // 统一将传入的字符串转成UTF8编码
  let encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedVal)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

export function isEmpty(obj) {
  if (obj === 0) return true
  if (Array.isArray(obj)) return !(obj.length > 0)
  return obj === null || obj === undefined || obj === '' || obj === isNaN
}
